import { PageTitle } from '../../../../../_metronic/layout/core'
import { FC, useEffect, useMemo } from 'react'
import { BreadCrumbs } from '../../../../components/BreadCrumbs/breadCrumbrs'
import { i18n } from '../../../../translate/i18n'
import { ModularDataTable } from '../../../../components/ModularDataTable'
import { usePluginsSpace } from '../factory/usePluginspaces'
import { generateColumnsPluginSpace } from '../factory/generateColumns'
import { createActionsPluginSpace } from '../factory/generateActions'
import { Loading } from '../../../../components/Loading/Loading'
import { useNavigate } from 'react-router-dom'
const SwaggerPermissionContent: FC = () => {
    const { pluginSpaces,setLoading,getPluginSpaces, handlePaginationChange, handleDataChange, handleSortingChange,loading, pagination, sorting, tableLoading } = usePluginsSpace()
    const navigate = useNavigate()

    const columns = useMemo(
        () => generateColumnsPluginSpace(),
        []
    )

    const actions = useMemo(
        () => createActionsPluginSpace({ navigate }),
        [navigate]
    )

      async function loadPage() {
        setLoading(true)
         await getPluginSpaces()
        setLoading(false)
    }

    useEffect(()=>{
        loadPage()
    },[])

    if (loading){
        return <Loading />
    }


    return (
        <div className='row g-5 gx-xxl-12'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12'>
                <div className='card-header py-5'>
                    <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bolder fs-3 mb-1'>
                            {i18n.t(`swagger.title`)}
                        </span>
                        <BreadCrumbs />
                        <span className='text-muted mt-1 fw-bold fs-7'>
                            {i18n.t(
                                `swagger.subTitle`
                            )}
                        </span>
                    </h3>


                </div>

                <div className='card-body'>
                    <ModularDataTable
                        data={pluginSpaces}
                        columns={columns}
                        actions={actions}
                        pagination={pagination}
                        onPaginationChange={handlePaginationChange}
                        sorting={sorting}
                        onSortingChange={handleSortingChange}
                        onDataChange={handleDataChange}
                        searchable={true}
                        searchPlaceholder='Pesquisar pluginSpaces...'
                        loading={tableLoading}
                        selectable={false}
                        striped={false}
                        hover={false}
                        size='md'
                        className='table-row-bordered table-row-gray-200'
                        alterColumns
                        persistPageKey="produtos"
                        persistContextKey="default"
                    />
                </div>
            </div>
        </div>
    )
}


const SwaggerPermission: FC = () => {
    return (
        <>
            <PageTitle
                breadcrumbs={[
                    { title: 'Swagger Permissions', path: 'swagger_permissions', isActive: true },
                ]}
            >
                Swagger Permissions
            </PageTitle>
            <SwaggerPermissionContent />
        </>
    )
}

export { SwaggerPermission }